<template>
  <div>
    <div class="title mb-3">
      {{ isAffiliateAuth ? "Internal" : "Affiliate" }} Memo
    </div>
    <div>
      <div
        v-if="!isMemoEdit"
        @click="editMemo()"
        class="pa-3 indigo lighten-5 rounded-lg"
        :class="hasEdit('customers') ? 'cursor-pointer' : ''"
        v-html="memoHTML"
      ></div>
      <template v-else>
        <textarea-field v-model="memo" :rows="10" />
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            class="mr-3"
            @click="isMemoEdit = false"
            outlined
            :disabled="isMemoLoading"
            >Cancel</v-btn
          >
          <v-btn
            color="success"
            depressed
            @click="updateMemo()"
            :loading="isMemoLoading"
            >Save Memo
          </v-btn>
        </div>
      </template>
    </div>
    <v-divider class="my-3" />
  </div>
</template>
<script>
import TextareaField from "@/components/ui/form/TextareaField.vue";
import {doc, updateDoc} from "firebase/firestore";
import {colClients} from "@/assets/utils/firebase.utils";

export default {
  name: "ClientAffiliateMemo",
  components: { TextareaField },
  data() {
    return {
      memo: "",
      isMemoEdit: false,
      isMemoLoading: false,
    };
  },
  computed: {
    memoHTML() {
      let memo = this.currentClient.affiliate_memo || "-";
      return memo.split("\n").join("<br/>");
    },
  },
  methods: {
    editMemo() {
      this.isMemoEdit = true;
      this.memo = this.currentClient.affiliate_memo || "";
      this.$nextTick(() => {
        const textarea = this.$el.querySelector("textarea");
        if (textarea) textarea.focus();
      });
    },
    async updateMemo() {
      try {
        this.isMemoLoading = true;
        await updateDoc(doc(colClients, this.$route.params.id), {
          affiliate_memo: this.memo,
        });
        this.isMemoEdit = false;
        this.isMemoLoading = false;
      } catch (error) {
        this.isMemoLoading = false;
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped></style>
